const devURL = process.env.REACT_APP_API_BASE_URL;

const baseURL = devURL;

export default baseURL;
